import React from "react";

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';

import UserContext from '../context/UserContext';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels, ControlTypes, MitigationStatus } from './RiskLevels'


class CloseMitigationDialog extends React.Component {

	static contextType = UserContext;

	state = {
		mitigation: { mitigationID: 0, status: 0, probabilityAfter: 1, consequenceAfter: 1 },
		adjustRisk:false,
	};


	componentDidMount() {
		
	}

	componentDidUpdate(prevProps, prevState) {		
		if (prevProps.mitigation !== this.props.mitigation) {		
			this.setState({ mitigation: this.props.mitigation});
		}
		if (prevState.mitigation !== this.state.mitigation) {
			if (this.state.mitigation.status === 5
				&& !(this.state.mitigation.probabilityAfter > this.props.risk.probability || this.state.mitigation.consequenceAfter > this.props.risk.consequence)
				&& !(this.state.mitigation.probabilityAfter === this.props.risk.probability && this.state.mitigation.consequenceAfter === this.props.risk.consequence)) {
				this.setState({ adjustRisk: true });
			} else {
				this.setState({ adjustRisk: false });
			}
			
		}
	}

	cancelDialog() {
		this.setState({ adjustRisk: false });
		if (this.props.onClose != null) {
			this.props.onClose(false);
		}
	}

	closeDialog() {
		if (this.props.onClose != null) {
			this.props.onClose(true, this.state.adjustRisk);
		}
		this.setState({ adjustRisk: false });
	}

	render() {
		var riskText =  (
			<p>You are about to archive an unfinished mitigation without adjusting the risk assesment. Do you really want to archive <b>{this.state.mitigation.name}</b>?</p>
		);
		
		if (this.state.mitigation && this.state.mitigation.status === 5) {
			if (this.state.mitigation.probabilityAfter === this.props.risk.probability && this.state.mitigation.consequenceAfter === this.props.risk.consequence) {
				riskText = (
					<p>You are about to archive an finished mitigation but it is not set up to change the risk assesment. Do you really want to archive <b>{this.state.mitigation.name}</b>?</p>
				);
			} else if (this.state.mitigation.probabilityAfter > this.props.risk.probability || this.state.mitigation.consequenceAfter > this.props.risk.consequence) {
				riskText = (
					<p>Either the target probability, consequence or both of the mitigation are set higher than the in the risk. You can archive the mitigation as finished but need to manually adjust the risk assesment</p>
				);
			} else if (this.state.mitigation.probabilityAfter < this.props.risk.probability && this.state.mitigation.consequenceAfter < this.props.risk.consequence) {
				riskText = (
					<div>
						<p>The mitigation is set up to lower both the probability of the risk from <b>{ProbabilityLevels[this.props.risk.probability].text}</b> to <b>{ProbabilityLevels[this.state.mitigation.probabilityAfter].text} </b>
							and the consequence of the risk from <b>{ConsequenceLevels[this.props.risk.consequence].text}</b> to <b>{ConsequenceLevels[this.state.mitigation.consequenceAfter].text}</b></p>
						<br/>
						<Checkbox inputId="adjustRisk" onChange={(e) => this.setState({ adjustRisk: !this.state.adjustRisk })} checked={this.state.adjustRisk} />
						<label htmlFor="adjustRisk" className="ml-2" >Adjust risk assesment automatically</label>
					</div>
				);
			} else if (this.state.mitigation.probabilityAfter < this.props.risk.probability) {
				riskText = (
					<div>
						<p>The mitigation is set up to lower the probability of the risk from <b>{ProbabilityLevels[this.props.risk.probability].text}</b> to <b>{ProbabilityLevels[this.state.mitigation.probabilityAfter].text}</b></p>
						<br/>
						<Checkbox inputId="adjustRisk" onChange={(e) => this.setState({ adjustRisk: !this.state.adjustRisk })} checked={this.state.adjustRisk} />
						<label htmlFor="adjustRisk" className="ml-2" >Adjust risk assesment automatically</label>
					</div >
				);
			} else if (this.state.mitigation.consequenceAfter < this.props.risk.consequence) {
				riskText = (
					<div>
						<p>The mitigation is set up to lower the consequence of the risk from <b>{ConsequenceLevels[this.props.risk.consequence].text}</b> to <b>{ConsequenceLevels[this.state.mitigation.consequenceAfter].text}</b></p>
						<br />
						<Checkbox inputId="adjustRisk" onChange={(e) => this.setState({ adjustRisk: !this.state.adjustRisk })} checked={this.state.adjustRisk} />
						<label htmlFor="adjustRisk" className="ml-2" >Adjust risk assesment automatically</label>
					</div >
				);
			}
		}


		const footerContent = (
			<div>
				
				<div style={{ float: 'right' }}>
					<Button label="Cancel" icon="pi pi-times" onClick={() => this.cancelDialog()} className="p-button-secondary" />
					<Button label="Archive" icon="pi pi-check" onClick={() => this.closeDialog()} />
				</div>
			</div >
		);
		return (
			<Dialog header="Archive mitigation" visible={this.props.visible} style={{ minWidth: '30vw', width: '35vw', overflow: 'hidden' }} maximizable footer={footerContent}
				modal contentStyle={{ height: '300px' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>
					<span>{riskText} </span>
				</div>		
			</Dialog>
		);
	}
}
export default (CloseMitigationDialog);
